import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { get, post, put } from '../../../services/apiController';
import { toast } from 'react-toastify';
import { get_auth_key, getStoredData } from '../../../util';
import moment from 'moment';

const AddEditNamkeenOrderForm = ({ orderId, namekeenOrderData, callback }) => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const branchId = storedData.role === 'cake-manager' ? storedData?.locationId[0] : null;

  const [namkeens, setNamkeens] = useState([]);
  const [location, setLocation] = useState(null);
  useEffect(() => {
    if (branchId && storedData.role === 'cake-manager') {
      get('/branches/?id=' + branchId).then((res) => {
        if (res.data.rows.length) {
          setLocation(res.data.rows[0]);
        }
      });
    }
  }, [branchId, storedData?.role]);

  const formFields = {
    date: '',
    tripNumber: '',
    clientName: '',
    namkeenId: '',
    quantity: '',
    number: '',
    remarks: '',
  };

  const [formData, setFormData] = useState(orderId ? namekeenOrderData : formFields);

  function FetchNamkeens() {
    get(`/cake/festival-namkeens/namkeen-list`)
      .then((response) => {
        setNamkeens(response.data);
      })
      .catch((err) => console.log('Err', err));
  }

  useEffect(() => {
    FetchNamkeens();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (orderId) {
      put(formData, `/cake/festival-namkeens/orders/${orderId}`)
        .then((res) => {
          toast.success(res.data.message);
          setFormData(formFields);
          callback();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message);
        });
    } else {
      post(formData, '/cake/festival-namkeens/order-create')
        .then((res) => {
          toast.success(res.data.message);
          setFormData(formFields);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message);
        });
    }
  };

  return (
    <>
      <Row className="px-2">
        <Form onSubmit={handleSubmit}>
          <div className="container mt-3">
            <Row className="mb-3">
              <Col xs={3}>
                <Form.Label htmlFor="date">Delivery Date</Form.Label>
                <Form.Control
                  type="date"
                  className="form-control"
                  id="date"
                  name="date"
                  value={formData.date}
                  min={!orderId && moment().add('1', 'days').format('YYYY-MM-DD')}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col xs={3}>
                <Form.Label htmlFor="tripNumber">Trip Number</Form.Label>
                <Form.Select
                  className="form-control"
                  id="tripNumber"
                  name="tripNumber"
                  value={formData.tripNumber}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Trip Number</option>
                  {[1, 2].map((trip) => (
                    <option key={trip} value={trip}>
                      {trip}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={3}>
                <Form.Label htmlFor="clientName">Client Name</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  id="clientName"
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleChange}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={3}>
                <Form.Label htmlFor="namkeenId">Namkeen</Form.Label>
                <Form.Select id="namkeenId" name="namkeenId" value={formData.namkeenId} onChange={handleChange} required>
                  <option value="">Select Namkeen</option>
                  {namkeens.map((namkeen) => (
                    <option key={namkeen.id} value={namkeen.id}>
                      {namkeen.name}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={3}>
                <Form.Label htmlFor="quantity">Quantity (In grams)</Form.Label>
                <Form.Select
                  className="form-control"
                  id="quantity"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Quantity</option>
                  {[50, 75, 100, 125, 150, 200, 250, 300, 400, 500, 1000].map((qty) => (
                    <option key={qty} value={qty}>
                      {qty}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs={3}>
                <Form.Label htmlFor="number">Number (In pieces)</Form.Label>
                <Form.Control
                  type="number"
                  className="form-control"
                  id="number"
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                  min={50}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={6}>
                <Form.Label htmlFor="remarks">Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  className="form-control"
                  id="remarks"
                  name="remarks"
                  rows="3"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </Col>
            </Row>
            {location && (
              <Col className="mb-3" xs={4}>
                <Form.Label>Location</Form.Label>
                <Form.Control
                  disabled
                  className="input"
                  value={`${location?.number} - ${location?.name}`}
                  type="text"
                  placeholder="Location"
                />
              </Col>
            )}
            <Col xs={4}>
              <button type="submit" className="btn app-btn-primary">
                {orderId ? 'Update Order' : 'Submit Order'}
              </button>
            </Col>
          </div>
        </Form>
      </Row>
    </>
  );
};

export default AddEditNamkeenOrderForm;
